(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('WarehouseRecords', WarehouseRecords);

    WarehouseRecords.$inject = ['$resource'];

    function WarehouseRecords ($resource) {
        var resourceUrl =  'api/warehouse-records/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method:'PUT',
                isArray: false
            },
            'delete': {
                method:'DELETE'
            } ,
            'page': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }

})();
